import type { PartialDeep } from 'type-fest'
import type { FormContext } from 'vee-validate'
import * as z from 'zod'
import { PaymentModelStatus } from '~/constants/receiptModel'

type Translate = (key: string) => string

function optionalFileSchema() {
  return z.string().nullish()
}

function requiredFileSchema(t: Translate) {
  return optionalFileSchema().refine(fileName => Boolean(fileName?.length), t('form.file_required'))
}

export interface InvoiceSchemaParams {
  t: Translate
  requireServiceProductInvoice: boolean
  isSeparateInvoices: boolean
  hasFinancingCommissionToReceive: boolean
  isPartnerSupplier?: boolean
  paymentModelStatus?: string
}

export function getSchema({
  t,
  requireServiceProductInvoice,
  isSeparateInvoices,
  hasFinancingCommissionToReceive,
  isPartnerSupplier = true,
  paymentModelStatus,
}: InvoiceSchemaParams) {
  const requireEquipmentInvoice = isSeparateInvoices && (
    isPartnerSupplier
    || paymentModelStatus === PaymentModelStatus.AWAITING_INVOICE_EQUIPMENT
  )
  return z.object({
    service_product: requireServiceProductInvoice ? requiredFileSchema(t) : optionalFileSchema(),
    commission: hasFinancingCommissionToReceive ? requiredFileSchema(t) : optionalFileSchema(),
    products: requireEquipmentInvoice ? requiredFileSchema(t) : optionalFileSchema(),
    correction_letter: optionalFileSchema(),
  })
}

export type FormSchema = z.infer<ReturnType<typeof getSchema>>
export type Form = FormContext<PartialDeep<FormSchema>>
export type Field = keyof(FormSchema)

export function getInitialValues(): Partial<FormSchema> {
  return {
    commission: null,
    products: null,
    service_product: null,
    correction_letter: null,
  }
}
